import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Team from "@/pages/Team";
import TeamMember from "@/pages/TeamMember";
import CEO from "@/pages/CEO";
import Activity from "@/pages/Activity";
import ActivityDetail from "@/pages/ActivityDetail";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App font-body text-michma-ink bg-white">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/team" element={<Team />} />
            <Route path="/team/:slug" element={<TeamMember />} />
            <Route path="/ceo" element={<CEO />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/activity" element={<Activity />} />
            <Route path="/activity/:slug" element={<ActivityDetail />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
